/**
 * Project card colours — pure (no Tauri), shared by projectsStore and the pure
 * graph builder without an import cycle.
 */
export const PROJECT_COLORS = Object.freeze(['#8869eb', '#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#ec4899', '#14b8a6', '#64748b']);

const HEX = '#[0-9a-fA-F]{6}';
const GRADIENT_RE = new RegExp(`^linear-gradient\\(135deg, (${HEX}), (${HEX})\\)$`);

/** A card colour like the boards' (TaskBoardTab randomGradient). */
export function randomProjectGradient() {
  const hex = () => `#${Math.floor(Math.random() * 0xffffff).toString(16).padStart(6, '0')}`;
  return `linear-gradient(135deg, ${hex()}, ${hex()})`;
}

/**
 * Only a palette hex or the exact board gradient shape is kept — the value is
 * synced from other devices and ends up in a style attribute, so free-form CSS
 * is never stored.
 */
export function normalizeColor(value) {
  if (PROJECT_COLORS.includes(value)) return value;
  if (typeof value === 'string' && GRADIENT_RE.test(value)) return value;
  return PROJECT_COLORS[0];
}

/** A solid colour for places that cannot draw a gradient (graph nodes, dots). */
export function projectSolidColor(value) {
  const m = typeof value === 'string' ? GRADIENT_RE.exec(value) : null;
  return m ? m[1] : normalizeColor(value);
}
